import React from 'react';

import { AiFillInfoCircle } from 'react-icons/ai';

const CustomTooltip = ({ field }) => {
  return field.tooltipText ? (
    <span className="form-icon" data-tip={field.tooltipText}>
      <AiFillInfoCircle />
    </span>
  ) : (
    ''
  );
};

export default CustomTooltip;
